import React, { useEffect, useRef } from 'react';

const GoogleMap = () => {
  // const [openModal, setOpenModal] = useState(false);
  // const [modalContent, setModalContent] = useState(null);
  const mapRef = useRef(null); // Referencia para almacenar el mapa
  const markersRef = useRef([]);

  // const handleMarkerClick = (locationTitle) => {
  //   if (locationTitle === 'Colombia') {
  //     setModalContent('Colombia');
  //   } else if (locationTitle === 'El Salvador') {
  //     setModalContent('El Salvador');
  //   }
  //   setOpenModal(true);
  // };

  // const handleClose = () => {
  //   setOpenModal(false);
  //   setModalContent(null);
  // };

  const goToLocation = (lat, lng) => {
    if (mapRef.current) {
      mapRef.current.setCenter({ lat, lng }); // Centra el mapa en las coordenadas
      mapRef.current.setZoom(15); // Ajusta el nivel de zoom
    }
  };

  useEffect(() => {
    window.initMap = () => {
      const map = new window.google.maps.Map(document.getElementById('map'), {
        zoom: 3,
        center: { lat: 10, lng: -75 },
      });

      mapRef.current = map; // Almacena la instancia del mapa en la referencia

      const locations = [
        { lat: 13.69294, lng: -89.21819, title: 'El Salvador', clickable: false },
        { lat: 6.1266762801573895, lng: -75.42021672073368, title: 'Colombia', clickable: true },
      ];

      const bounds = new window.google.maps.LatLngBounds();

      locations.forEach((location) => {
        const marker = new window.google.maps.Marker({
          position: location,
          map: map,
          title: location.title,
        });
        markersRef.current.push(marker);

        if (location.clickable) {
          marker.addListener('click', () => {
            goToLocation(location.lat, location.lng);
          });
        }

        bounds.extend(location);
      });

      map.fitBounds(bounds);
    };

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtmlSb-geoSAMqyAZgNINLLybVIFrbFvM&callback=initMap`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      delete window.initMap;
    };
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div id="map" style={{ width: '100%', height: '100%' }} />
    </div>
  );
};

export default GoogleMap;
